{
  "loading": "Загрузка...",
  "placeholder": "Выбрать параметр..."
}
